import { Reveal } from "./Reveal";
import { CONTACT } from "./data";
import LeadForm from "./LeadForm";

export default function FinalCta() {
  return (
    <section id="contacto" data-testid="final-cta-section" className="relative py-28 sm:py-40 bg-[#1c242f] overflow-hidden">
      <div className="absolute inset-0 spotlight opacity-70" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <Reveal>
            <p className="mono text-[11px] uppercase tracking-[0.3em] text-[#bfa360] mb-6">Último paso</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-[#f4f2ea]">
              Solo 28 familias<br />vivirán <span className="gold-text italic">aquí</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-7 text-[#a8ac9b] text-base sm:text-lg leading-relaxed max-w-md">
              El viento no espera. Agenda tu visita hoy y conoce el departamento que se
              adapta a tu estilo de vida, antes de que se agoten.
            </p>
          </Reveal>
          <Reveal delay={0.22}>
            <div className="mt-8 flex items-center gap-6 mono text-[11px] uppercase tracking-[0.22em] text-[#a8ac9b]">
              <span className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-[#25D366] animate-pulse" /> Asesor en línea</span>
              <span>{CONTACT.phone}</span>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.12} y={36}>
          <LeadForm
            idPrefix="lead-form"
            title="Agenda tu visita privada"
            subtitle="Te respondemos por WhatsApp en minutos."
            source="final_cta_form"
          />
        </Reveal>
      </div>
    </section>
  );
}
